import { getJson } from "../../api";

export interface ConsentDetailsResponse {
  clientId: string;
  clientName: string;
  state: string;
  principalName: string;
  requestedScopes: string[];
  previouslyApproved: string[];
  authorizeEndpoint: string;
}

export async function getConsentDetails(params: {
  clientId: string;
  scope: string;
  state: string;
}): Promise<ConsentDetailsResponse> {
  return getJson<ConsentDetailsResponse>("/api/auth/oauth2/consent", {
    client_id: params.clientId,
    scope: params.scope,
    state: params.state,
  });
}
